// notificationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Notification {
  id: number;
  from_user: number;
  to_user: number | null;
  message: string;
  module_id: number;
  module_uuid: string;
  module: string;
  type: string;
  is_read: string;
  action_taken: string;
  notification_for: string;
  to_user_name: string;
  created_at: string;
  position_name?: string;
  candidate_name?: string;
}

interface NotificationState {
  notifications: Notification[];
  filtered_count: number;
  total_count: number;
  loaded: boolean;
}

const initialState: NotificationState = {
  notifications: [],
  filtered_count: 0,
  total_count: 0,
  loaded: false,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotifications(state, action: PayloadAction<{ notifications: Notification[], filtered_count: number, total_count: number }>) {
      state.notifications = action.payload.notifications;
      state.filtered_count = action.payload.filtered_count;
      state.total_count = action.payload.total_count;
      state.loaded = true;
    },
  },
});

export const { setNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
